import { useEffect, useState } from "react";
import { Input } from "../ReadonlyAwareInputs";

const BLOCKED_CHARACTERS = ["/", "\\", "#"];

const getErrorMessage = (groupName) => {
  if (!groupName || groupName === "") {
    return "Group name cannot be empty";
  }

  if (/\s$/.test(groupName)) {
    return `Group Name cannot have a trailing space`;
  }

  for (const char of BLOCKED_CHARACTERS) {
    if (groupName?.includes(char)) {
      return `Group Name cannot contain "${char}"`;
    }
  }
};

export function GroupNameInput({
  error: parentError,
  errorNode: parentErrorNode,
  value,
  onChange,
  setError,
  ...args
}) {
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    const message = getErrorMessage(value);
    setErrorMessage(message);
    setError(Boolean(message));
  }, [value]);

  const errorNode = (
    <a style={{ color: "indianred" }}>
      {(parentError && parentErrorNode) || errorMessage}
    </a>
  );

  return (
    <Input
      value={value}
      onChange={onChange}
      errorNode={errorNode}
      error={parentError}
      required={true}
      {...args}
    />
  );
}
